export const circleForm = [
  {
    type: "Number",
    label: "Code*",
    id: "Code",
    placeholder: "Category code",
  },
  {
    type: "text",
    label: "Name*",
    id: "Name",
    placeholder: "Category Name",
  },
  {
    type: "text",
    label: "Suppourting Document Label*",
    id: "Suppourting",
    placeholder: "Suppourting Document Label",
  },
  {
    type: "text",
    label: "Remarks",
    id: "Remarks",
    placeholder: "Remarks",
  },
];
